import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import CButton from "./CButton";
import { useEffect, useState } from "react";

const EndOfMonthPopup = ({handleNext}) => {
  const [open, setOpen] = useState(false);
  const userDetails =
    JSON.parse(localStorage.getItem("user")) ||
    JSON.parse(sessionStorage.getItem("user"));

  useEffect(() => {
    if (userDetails.endOfMonthNotification) {
      setOpen(true);
    }
  }, [userDetails.endOfMonthNotification]);

  const handleEndOfMonthNotification = () => {
    const updatedUserDetails = {
      ...userDetails,
      endOfMonthNotification: false,
    };
    localStorage.setItem("user", JSON.stringify(updatedUserDetails));
    handleNext()
    setOpen(false);
  };

  return (
    <Dialog open={open} className="custom-dialog">
      <DialogContent>
        <DialogContentText sx={{pt:4,textAlign:"center"}}>
          {userDetails.endOfMonthNotificationMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt:1, display: "flex", justifyContent: "center" }}>
        <CButton onClick={handleEndOfMonthNotification} className="btn-primary">
          Okay
        </CButton>
      </DialogActions>
    </Dialog>
  );
};

export default EndOfMonthPopup;
